module.exports = __webpack_public_path__ + "static/mobile1-e04242cd5ef14103ba898e480ba7dff8.png";